import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import {
  SwalAlert,
  setAuthProps,
  getAuthProps,
  ERP_BASE_URL,
} from "../services";

const SSO_LOGIN_API_URL = "https://api.gyandiksha.in/auth/teacher/sso-login";

const dummyData = {
  status: true,
  code: 200,
  message: "SUCCESS",
  data:
    /// ----------> Skill Passport Nodal Officer Role <----------
    // {
    //     "token": "eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiI1NDYxOSIsIlJPTEVfSUQiOjEsIlJFR19JRCI6NTQ2MTksIkRFUFRfSUQiOjc4LCJTVUJST0xFX0lEIjowLCJQT1JUQUxfSUQiOjkyLCJJTlNUX0lEIjoyMiwiUk9MRV9NUEdfVVVJRCI6ImQ2NGMzMDRkLWYzMDEtMTFlZC1iOWI1LTAwNTA1NmE4NWExZCIsImlhdCI6MTc4NzgyMjI5MiwiZXhwIjoxNzg3OTA4NjkyfQ.xRGjpFRwBy_tY9IdGhzEPsw2_tjNN0acLLa1tdMpyU8DVeRMg2DLG5X9kTZGEDrqdJDKr-GEJhU_xAYdO6Zt8A",
    //     "refreshToken": "eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiI1NDYxOSIsIlJPTEVfSUQiOjE4NSwiUkVHX0lEIjo1NDYxOSwiREVQVF9JRCI6NzgsIlNVQlJPTEVfSUQiOjAsIlBPUlRBTF9JRCI6OTYsIklOU1RfSUQiOjIyLCJST0xFX01QR19VVUlEIjoiYzZkNTAzZmQtZDY1Yi00OGMzLWEwYTMtZGFhMTU0OWZkNWU2IiwiaWF0IjoxNzg3MDU1OTI4LCJleHAiOjE3ODgzNTE5Mjh9.9gK1rfqTZzxYST21d9SyU12IL3uRhootHNcqob5eI4NhcNNV2EMfsXo84Mrg5bNuVYCNWaWkkcKg_mKUmX1v9Q",
    //     "firstName": "RASIKLAL",
    //     "middleName": "BABULAL",
    //     "lastName": "SHARMA",
    //     "email": "rbsharma71264@gmail.com",
    //     "instituteName": "L.D. College OF Engineering, Ahmedabad",
    //     "departmentName": "Admin",
    //     "instituteId": 22,
    //     "departmentId": 78,
    //     "roleId": 185,
    //     "fullName": "RASIKLAL BABULAL SHARMA",
    //     "isErpLoggedIn": true
    // }

    /// ----------> Staff Role <----------
    // {
    //     "token": "eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiIxNDI5MCIsIlJPTEVfSUQiOjEsIlJFR19JRCI6MTQyOTAsIkRFUFRfSUQiOjQ4LCJTVUJST0xFX0lEIjowLCJQT1JUQUxfSUQiOjkyLCJJTlNUX0lEIjoyMiwiUk9MRV9NUEdfVVVJRCI6ImQ2MmNlZWE5LWYzMDEtMTFlZC1iOWI1LTAwNTA1NmE4NWExZCIsImlhdCI6MTc4NzgyMjQ5OSwiZXhwIjoxNzg3OTA4ODk5fQ.dsYX80j2iryCXkUZ7ZWC6vLnd02IrzJz3BAO1lYKXFFOo75e3fcNfnVcCucqvJJ8Hsv4NjvrokMnjl7D3WOmxA",
    //     "refreshToken": "eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiIxNDI5MCIsIlJPTEVfSUQiOjEsIlJFR19JRCI6MTQyOTAsIkRFUFRfSUQiOjQ4LCJTVUJST0xFX0lEIjowLCJQT1JUQUxfSUQiOjkyLCJJTlNUX0lEIjoyMiwiUk9MRV9NUEdfVVVJRCI6ImQ2MmNlZWE5LWYzMDEtMTFlZC1iOWI1LTAwNTA1NmE4NWExZCIsImlhdCI6MTc4NjY5MTU2MiwiZXhwIjoxNzg3OTg3NTYyfQ.K2kB64_-c5fmh8jiQTzgRjk13QtAXpJxxJlndjguvW5hfXia6VsKp9tylWYNNOJehj4kCWLzP9QnQhIv4JTfRQ",
    //     "firstName": "Apexa",
    //     "middleName": "Bharat",
    //     "lastName": "Dharankar",
    //     "email": "apexa.dharankar@gujgov.edu.in",
    //     "instituteName": "L.D. College OF Engineering, Ahmedabad",
    //     "departmentName": "General",
    //     "instituteId": 22,
    //     "departmentId": 48,
    //     "roleId": 1,
    //     "governmentId": "apexa.dharankar@gujgov.edu.in",
    //     "fullName": "Apexa Bharat Dharankar",
    //     "isErpLoggedIn": true
    // }

    /// ----------> Principal Role <----------
    // {
    //     "token": "eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiIyNjY5MCIsIlJPTEVfSUQiOjIsIlJFR19JRCI6MjY2OTAsIkRFUFRfSUQiOjc4LCJTVUJST0xFX0lEIjowLCJQT1JUQUxfSUQiOjkyLCJJTlNUX0lEIjoyMiwiUk9MRV9NUEdfVVVJRCI6ImZhZmZhZGM1LWNiZDYtMTFlZS1hODIwLTAwNTA1NmE4NWExZCIsImlhdCI6MTc4NzczNTA4MywiZXhwIjoxNzg3ODIxNDgzfQ.mSE6CU_aIVqxEBWJFcxBxkv9DGbP0WM4BkZGtx43jGxUOO3k55k9zTHLvnhicApeNBBWw4Kb9DwYFltvxvtrcQ",
    //     "refreshToken": "eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiIyNjY5MCIsIlJPTEVfSUQiOjIsIlJFR19JRCI6MjY2OTAsIkRFUFRfSUQiOjc4LCJTVUJST0xFX0lEIjowLCJQT1JUQUxfSUQiOjkyLCJJTlNUX0lEIjoyMiwiUk9MRV9NUEdfVVVJRCI6ImZhZmZhZGM1LWNiZDYtMTFlZS1hODIwLTAwNTA1NmE4NWExZCIsImlhdCI6MTc4NzEyMzkwNywiZXhwIjoxNzg4NDE5OTA3fQ.mEEBYked_VYVX-oIhHBBRoPFIma_9Xpc3xVFdIaPcVzb3Pbc1-Lpkj9nmdn8tJbW1VBE-g680o60O29dryUV4A",
    //     "firstName": "Nilay",
    //     "middleName": "N",
    //     "lastName": "Bhuptani",
    //     "email": "nilay.bhuptani@gujgov.edu.in",
    //     "instituteName": "L.D. College OF Engineering, Ahmedabad",
    //     "departmentName": "Admin",
    //     "instituteId": 22,
    //     "departmentId": 78,
    //     "roleId": 2,
    //     "fullName": "Nilay N Bhuptani",
    //     "isErpLoggedIn": true
    // }

    /// ----------> HOD Role <----------
    // {
    //     "token": "eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiI0MDQwMyIsIlJPTEVfSUQiOjMsIlJFR19JRCI6NDA0MDMsIkRFUFRfSUQiOjIsIlNVQlJPTEVfSUQiOjAsIlBPUlRBTF9JRCI6OTQsIklOU1RfSUQiOjIyLCJST0xFX01QR19VVUlEIjoiZDY1NTZhNDYtZjMwMS0xMWVkLWI5YjUtMDA1MDU2YTg1YTFkIiwiaWF0IjoxNzg2OTU4NTU1LCJleHAiOjE3ODcwNDQ5NTV9.0dS0VtV6BL-yhN4cB1utCBFsf_pYVonZwdAuK5rYH_8aA5rZrk0K-AB3rYXHDNtxDlNN1-DLEYr2sjNmxl_miw",
    //     "refreshToken": "eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiI0MDQwMyIsIlJPTEVfSUQiOjMsIlJFR19JRCI6NDA0MDMsIkRFUFRfSUQiOjIsIlNVQlJPTEVfSUQiOjAsIlBPUlRBTF9JRCI6OTQsIklOU1RfSUQiOjIyLCJST0xFX01QR19VVUlEIjoiZDY1NTZhNDYtZjMwMS0xMWVkLWI5YjUtMDA1MDU2YTg1YTFkIiwiaWF0IjoxNzg2OTU4NTU1LCJleHAiOjE3ODgyNTQ1NTV9.ksyNWxe-mk7ftAXJ-L9YkzUq-cs4gOD6KvcLmlDVJT0a0tOWoixei4z9_nPwySjZETXrPSkqIVbdDUV8zxZFlQ",
    //     "firstName": "VIKRAMKUMAR",
    //     "middleName": "BABABHAI",
    //     "lastName": "PATEL",
    //     "email": "avivikram@gmail.com",
    //     "instituteName": "L.D. College OF Engineering, Ahmedabad",
    //     "departmentName": "Mechanical Engineering",
    //     "instituteId": 22,
    //     "departmentId": 2,
    //     "roleId": 3,
    //     "fullName": "VIKRAMKUMAR BABABHAI PATEL",
    //     "isErpLoggedIn": true
    // }

    /// ----------> Student Management Admin Role <----------
    // {
    //     "token": "eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiI1NDU2MyIsIlJPTEVfSUQiOjE4MywiUkVHX0lEIjo1NDU2MywiREVQVF9JRCI6NzgsIlNVQlJPTEVfSUQiOjAsIlBPUlRBTF9JRCI6MTAwLCJJTlNUX0lEIjoyMDIsIlJPTEVfTVBHX1VVSUQiOiI4Y2NmOTc1OS1mNmIwLTRkODYtYmRiNC1lMmYxODQyOGIyYWEiLCJpYXQiOjE3ODcxMzE5ODQsImV4cCI6MTc4NzIxODM4NH0.EcObby_zXpq6WrAnqRXkyOrdMaISfSweID6b3O8niPlkas8RkhVSUtm1_MANnsxB0SopkMMUNyJJJB-KpON7Sw",
    //     "refreshToken": "eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiI1NDU2MyIsIlJPTEVfSUQiOjE4MywiUkVHX0lEIjo1NDU2MywiREVQVF9JRCI6NzgsIlNVQlJPTEVfSUQiOjAsIlBPUlRBTF9JRCI6OTMsIklOU1RfSUQiOjIwMiwiUk9MRV9NUEdfVVVJRCI6IjhjY2Y5NzU5LWY2YjAtNGQ4Ni1iZGI0LWUyZjE4NDI4YjJhYSIsImlhdCI6MTc4NjQ1MDI5OSwiZXhwIjoxNzg3NzQ2Mjk5fQ.07g4mqX8d5-NBCdr9RpjMcZ3JfmqKDUMuALR3thKfP5J3NeAQHGRJ7O6lDwHJWn91ZlkCOR5LLvSxnG0FqN3Ng",
    //     "firstName": "Filipbhai",
    //     "middleName": "Yusufbhai",
    //     "lastName": "Solanki",
    //     "email": "filipsolanki07@gmail.com",
    //     "instituteName": "L.D. College OF Engineering, Ahmedabad",
    //     "departmentName": "Admin",
    //     "instituteId": 22,
    //     "departmentId": 78,
    //     "roleId": 183,
    //     "fullName": "Filipbhai Yusufbhai Solanki",
    //     "isErpLoggedIn": true
    // }
    // {
    //     "token": "eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiI1NDU2MyIsIlJPTEVfSUQiOjE4MywiUkVHX0lEIjo1NDU2MywiREVQVF9JRCI6NzgsIlNVQlJPTEVfSUQiOjAsIlBPUlRBTF9JRCI6MTAwLCJJTlNUX0lEIjoyMDIsIlJPTEVfTVBHX1VVSUQiOiI4Y2NmOTc1OS1mNmIwLTRkODYtYmRiNC1lMmYxODQyOGIyYWEiLCJpYXQiOjE3ODcxMzE5ODQsImV4cCI6MTc4NzIxODM4NH0.EcObby_zXpq6WrAnqRXkyOrdMaISfSweID6b3O8niPlkas8RkhVSUtm1_MANnsxB0SopkMMUNyJJJB-KpON7Sw",
    //     "refreshToken": "eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiI1NDU2MyIsIlJPTEVfSUQiOjE4MywiUkVHX0lEIjo1NDU2MywiREVQVF9JRCI6NzgsIlNVQlJPTEVfSUQiOjAsIlBPUlRBTF9JRCI6OTMsIklOU1RfSUQiOjIwMiwiUk9MRV9NUEdfVVVJRCI6IjhjY2Y5NzU5LWY2YjAtNGQ4Ni1iZGI0LWUyZjE4NDI4YjJhYSIsImlhdCI6MTc4NjQ1MDI5OSwiZXhwIjoxNzg3NzQ2Mjk5fQ.07g4mqX8d5-NBCdr9RpjMcZ3JfmqKDUMuALR3thKfP5J3NeAQHGRJ7O6lDwHJWn91ZlkCOR5LLvSxnG0FqN3Ng",
    //     "firstName": "Filipbhai",
    //     "middleName": "Yusufbhai",
    //     "lastName": "Solanki",
    //     "email": "filipsolanki07@gmail.com",
    //     "instituteName": "L.D. College OF Engineering, Ahmedabad",
    //     "departmentName": "Admin",
    //     "instituteId": 22,
    //     "departmentId": 78,
    //     "roleId": 183,
    //     "fullName": "Filipbhai Yusufbhai Solanki",
    //     "isErpLoggedIn": true
    // }

        /// ----------> Placemnet Management Admin Role <----------
    // {
    //     "token": "dVzuCG6uK7MZQGN+3BAPWp2cc2SJ5ZH8VZwp0AD4RjFtEq+57j1s5EMGHBYu2jZgeCI38EqaLpPukv4orO2EDr28AcKmuq2QEUFWi0BGfFtRLujjwNwfz9U+2/IuH+dC2yZLXwcc2Sav2uDYREyxwIQvm6V0QVQvrRutUupf/jDIaT5ppf6sw+mMx2E+Qvycl5rr5YTOMTYls6ACZ3V2aLe2ZiCsLOXG7+6I6o5BI78MTnKtJaoysKzWUxu1FEznlSyipV3xtvguxdmQSPnixYhNbm8TQUh5SiGZpZfXSzcrJiqcSTOZguDupjK+UpVRpMstdlNAyjsh52KTPX2lRBYQspoFY4v0aQRtwG3GQxfiNGfiUAWNg5lPpN81Tjayea6Z6omnIaa4o6gr8ottk+gb5GApAgLFqig7r+Wn//M=&projectUUID=07f048dd-1e72-11f0-92ba-005056a85a1d",
    //     "refreshToken": "eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiIxNzY3MCIsIlJPTEVfSUQiOjE5NiwiUkVHX0lEIjoxNzY3MCwiREVQVF9JRCI6NDIsIlNVQlJPTEVfSUQiOjAsIlBPUlRBTF9JRCI6OTUsIklOU1RfSUQiOjcsIlJPTEVfTVBHX1VVSUQiOiI4OGZhNGM0YS1iN2RmLTExZjEtYjU0MC0wMDUwNTZhOGRhNjciLCJpYXQiOjE3OTA0MDE1MzIsImV4cCI6MTc5MTY5NzUzMn0.8QLfw55Uxt-KaiorgaMMPGWnTmaoplu3NnSohKiNDYAfFfANvgPajY3SETSNBt6EmFDflYXmrPS0r48tWaTP6g",
    //     "firstName": "PRATIKKUMAR",
    //     "middleName": "BHARATBHAI",
    //     "lastName": "SOMAIYA",
    //     "email": "pratikkumar.somaiya@gujgov.edu.in",
    //     "instituteName": "Government Engineering College, Rajkot, Ahmedabad",
    //     "departmentName": "Applied Mechanics",
    //     "instituteId": 7,
    //     "departmentId": 42,
    //     "roleId": 196,
    //     "fullName": "PRATIKKUMAR BHARATBHAI SOMAIYA",
    //     "isErpLoggedIn": true
    // }


    //Scholarship Nodal Officer
   {"token":"eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiI1NDU4NSIsIlJPTEVfSUQiOjE5NCwiUkVHX0lEIjo1NDU4NSwiREVQVF9JRCI6NzgsIlNVQlJPTEVfSUQiOjAsIlBPUlRBTF9JRCI6OTUsIklOU1RfSUQiOjIyLCJST0xFX01QR19VVUlEIjoiOGFkNTM2N2EtZTcxMS00M2M1LTk2MDUtNmFkZGYwMDg0NjhmIiwiaWF0IjoxNzg5Nzk5ODg5LCJleHAiOjE3ODk4ODYyODl9.GFXdcvqhM7-bf709Xuw9W1XAxvWnuBfhYaWFsywzXO0n1VP3yNN9BJWleyM5hDE2V6E-gJl37MfUX1mgKdPp9Q","refreshToken":"eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiI1NDU4NSIsIlJPTEVfSUQiOjE5NCwiUkVHX0lEIjo1NDU4NSwiREVQVF9JRCI6NzgsIlNVQlJPTEVfSUQiOjAsIlBPUlRBTF9JRCI6OTUsIklOU1RfSUQiOjIyLCJST0xFX01QR19VVUlEIjoiOGFkNTM2N2EtZTcxMS00M2M1LTk2MDUtNmFkZGYwMDg0NjhmIiwiaWF0IjoxNzg5Nzk5ODg5LCJleHAiOjE3OTEwOTU4ODl9.amfHUiYXHshvPjvLm6Ei39llYzzgvC8vqEs5TKJiqzF3LUhGH172AdsZONbj6Gl4xJhbdY0vx9J14lSRxre7Fg","firstName":"Payalben","middleName":"Amthabhai","lastName":"Desai","email":"payaldesai354@gmail.com","instituteName":"L.D. College OF Engineering, Ahmedabad","departmentName":"Admin","instituteId":22,"departmentId":78,"roleId":194,"fullName":"Payalben Amthabhai Desai","isErpLoggedIn":true}

};

export const useSsoLogin = (enabled = true) => {
  const ssoLoginApiUrl = SSO_LOGIN_API_URL;
  const { t } = useTranslation();
  const { warning } = SwalAlert(t);
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    if (!enabled) {
      setIsReady(true);
      return;
    }

    // setAuthProps(dummyData.data);
    const authData = getAuthProps();
    const params = new URLSearchParams(window.location.search);
    const redirectToken = params.get("token");
    const ssoToken = redirectToken;

    if (authData || !ssoToken) {
      setIsReady(true);
      return;
    }

    let didRedirectToErp = false;

    const redirectToErp = async () => {
      const isConfirmed = await warning(
        "Technical Issue",
        "A technical issue occurred while processing your request. Please try again in a few moments.",
        true,
        "Redirect Back",
        false,
        "",
      );
      if (isConfirmed) {
        didRedirectToErp = true;
        window.location.href = `${ERP_BASE_URL}`;
      }
    };

    const ssoLogin = async () => {
      try {
        const response = await fetch(`${ssoLoginApiUrl}?token=${ssoToken}`);
        const result = await response.json();

        if (response.ok && result?.code === 200 && result?.data) {
          const modifyData = {
            ...result.data,
            fullName: [
              result?.data?.firstName,
              result?.data?.middleName,
              result?.data?.lastName,
            ]
              .filter(Boolean)
              .join(" "),
            isErpLoggedIn: true,
          };
          setAuthProps(modifyData);
        } else {
          await redirectToErp();
        }
      } catch (error) {
        await redirectToErp();
      } finally {
        if (redirectToken) {
          params.delete("token");
          const newSearch = params.toString();
          const newUrl = `${window.location.pathname}${newSearch ? `?${newSearch}` : ""}${window.location.hash}`;
          window.history.replaceState({}, "", newUrl);
        }
        if (!didRedirectToErp) {
          setIsReady(true);
        }
      }
    };

    ssoLogin();
  }, [enabled, ssoLoginApiUrl]);

  return isReady;
};
